import React from 'react';
import { Alert } from 'antd';
import { Colors, ColorsType } from '@common/tokens';
import { Icon, IconOfKind } from '@common/components';

const typesData = {
  info: {
    baseColorHash: Colors.skyHyperLight,
    icon: 'circleInfo',
    iconColor: 'skyRegular',
  },
  success: {
    baseColorHash: Colors.meadowHyperLight,
    icon: 'circleCheck',
    iconColor: 'grassMid',
  },
  error: {
    baseColorHash: Colors.coralHyperlight,
    icon: 'circleXmark',
    iconColor: 'coral',
  },
  warning: {
    baseColorHash: Colors.sunLighter,
    icon: 'triangleExclamation',
    iconColor: 'sunDarker',
  },
  neutral: {
    baseColorHash: Colors.steelLightest,
    icon: 'circleExclamation',
    iconColor: 'midnightLighter',
  },
};

export function Banner({
  children,
  type,
  closable,
  fontSize,
  showIcon = true,
  style,
}: {
  children: React.ReactNode;
  type: 'info' | 'success' | 'error' | 'warning' | 'neutral';
  closable?: boolean;
  fontSize?: string;
  showIcon?: boolean;
  style?: React.CSSProperties;
}) {
  const currentTypeData = typesData[type];
  const iconOfKind = {
    icon: currentTypeData.icon,
    kind: 'solid',
  } as IconOfKind;

  return (
    <>
      <Alert
        className="wk-banner"
        closable={closable}
        icon={
          <Icon
            {...iconOfKind}
            color={currentTypeData.iconColor as ColorsType}
          />
        }
        message={children ?? ''}
        showIcon={showIcon}
        style={{
          ...style,
          borderColor: currentTypeData.baseColorHash,
          backgroundColor: currentTypeData.baseColorHash,
          fontSize: fontSize,
        }}
      />
      <style jsx>{`
        :global(.wk-banner) {
          width: fit-content;
        }
        :global(.wk-banner.ant-alert.ant-alert-closable) {
          padding-right: 40px;
        }
      `}</style>
    </>
  );
}
